import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { merkeAnmeldeZiel } from "@/lib/auth/anmeldeZiel";
import { useAuth } from "@/lib/auth/AuthContext";

export function RequireAuth({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  const location = useLocation();

  if (status === "loading") {
    return (
      <main className="flex min-h-full items-center justify-center p-8">
        <p className="text-sm text-muted-foreground">Laden...</p>
      </main>
    );
  }

  if (status === "signed-out") {
    // TAGESMAIL-1: das GANZE Ziel (Pfad, `?…`, `#…`) merken — die
    // Microsoft-Anmeldung verlaesst die Seite, der Router-Zustand ueberlebt
    // das nicht. Nach der Anmeldung geht es genau hierher zurueck.
    merkeAnmeldeZiel(`${location.pathname}${location.search}${location.hash}`);
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}
